import { Inline } from '@atlaskit/primitives';
import SectionMessage from '@atlaskit/section-message';
import { useEffect, useState } from 'react';

import useLocalStorage from '@/components/common/hooks/useLocalStorage';
import { InstallationDetails, Organization } from '@/components/common/types';
import { useAppContext } from '@/store';

import OrderConfirmationIcon from '../../../assets/order-confirmation.svg';
import { OnboardingLayout } from '../OnboardingLayout';


export const Complete = () => {
    const { state } = useAppContext();
    const { userProfile } = state;
    const [orgs, setOrgs] = useState<Organization[] | null>(null);
    const [cloudSiteToOrgMap, setCloudSiteToOrgMap] = useState<Record<string, string> | null>(null);
    const [cloudId, setCloudId] = useState<string | null>(null);
    const [installationDetails, _] = useLocalStorage<InstallationDetails | null>('installation_details', null);

    useEffect(() => {
        const fetchOrgs = async () => {
            try {
                const result = await await fetch('/gateway/api/rovo-slack-svc/api/v1/cloudSites/list-orgs', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        aaid: userProfile?.account_id,
                        email: userProfile?.email
                    })
                });
                const data = await result.json();
                setOrgs(data);
            } catch (error) {
                console.error('Error fetching orgs:', error);
            }
        }
        fetchOrgs();
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const cloudId = urlParams.get('cloudId');

        setCloudId(cloudId);

        if(orgs){
            const map: Record<string, string> = {};
            orgs.forEach(org => {
                org.sites.forEach(site => {
                    map[site.id] = org.id;
                });
            });
            setCloudSiteToOrgMap(map);
        }
    }, [orgs]);

    const getSlackURL = () => {
        if(process.env['NODE_ENV'] === 'production'){
            return `https://slack.com/app_redirect?app=A08B0EYMUPR&team=${installationDetails?.teamId}`;
        } else {
            return `https://slack.com/app_redirect?app=A08RR0AKP51&team=${installationDetails?.teamId}`;
        }
    }

    const getAdminHubURL = () => {
        if(cloudSiteToOrgMap && cloudId){
            if(process.env['NODE_ENV'] === 'production'){
                return `https://admin.atlassian.com/o/${cloudSiteToOrgMap[cloudId]}/rovo`;
            } else {
                return `https://admin.stg.atlassian.com/o/${cloudSiteToOrgMap[cloudId]}/rovo`;
            }
        }
        return '';
    }

    return (
        <OnboardingLayout currentStep={3} onNextLabel="Chat with Rovo" onNext={() => {
            const url = getSlackURL()
            window.open(url, '_blank');
            return true;
        }}>
            <div>
                <h2><center>You’re all set up!</center></h2>
                <Inline alignBlock="center" alignInline="center">
                    <OrderConfirmationIcon />
                </Inline>                
                <SectionMessage appearance="success">
                    <p>Congratulations! You can now start adding Rovo to Slack channels.</p>
                </SectionMessage>

                <div style={{ marginTop: '20px' }}>
                    {cloudSiteToOrgMap && cloudId && <SectionMessage appearance="information">
                        <p>You’ve set up Rovo for Slack and added your cloud site!</p>
                        <p>You’re ready to use Rovo directly in Slack DMs and channels.</p>
                        <p>If you’d like Slack messages and channels to show up alongside your company knowledge in Rovo search results, connect Slack to Rovo in Atlassian Administration.</p>
                        <a href={getAdminHubURL()} target="_blank" rel="noreferrer">Connect Slack to Rovo</a>
                    </SectionMessage>}
                </div>

            </div>
        </OnboardingLayout>
    );
};